// !!!: This is a container component

import React, { Component } from 'react';
import './App.css';
import Bootstrap from './Bootstrap.js';
import Header from './Header.js';
import Main from './Main.js';
import { connect } from 'react-redux';
import {
  SET_SEARCH_TEXT
} from './actions/index'

// import wannasGenesis from './wannas.json';

/**
  DONE: Map AIzaSyA3Zh63WAJ7KhnnTv3_0RHf-nSr_X0U_AU
  TODO: Search to add
  DONE: Modularize

  DONE: Ref usage direct from component

  TODO: Create new item
  TODO: Filter things by user
  TODO: Things with users 
  TODO: Things can be joined
  TODO: Things can be disconnected
  TODO: Float cards
*/

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      wannas: []
    };
  }

  render() {
    let content;

    if (this.props.user) {
      content = (
        <div className="App">
          <Header
            onSearchTextChange={text => this.onSearchTextChange(text)}
            onSearch={text => this.onSearch(text)}
          />

          <Main
            wanna={this.props.searchText}
          />
        </div>
      );
    } else {
      content = (
        <div className="App">
          <Bootstrap/>
        </div>
      );
    }

    return (
      content
    );
  }

  onSearchTextChange(text) {
    console.log("New input: ", text);

    // TODO: Debug, Fetch wanna options that are matching
  }

  onSearch(text) {
    console.log('Wanna: ' + text);
    const self = this;

    this.props.firebase
      .firestore()
      .collection('bees')
      .doc(this.props.user.uid)
      .update({
        wanna: text
      })
      .then(function() {
        console.log("Document successfully updated!");

        self.props.dispatch({
          type: SET_SEARCH_TEXT,
          searchText: text
        });
      })
      .catch(function(error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      });
  }
}

const mapStateToProps = (state, ownProps) => {
  console.log("Hop", state);

  return Object.assign({}, ownProps, {
    searchText: state.searchText,
    user: state.user,
    firebase: state.firebase
  });
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js